import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { CompanyService } from 'src/services/company.service';

@Component({
    selector: 'app-cp-overview',
    templateUrl: './cp-overview.component.html',
    styleUrls: ['./cp-overview.component.scss'],
    standalone: false
})
export class CpOverviewComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private companyService = inject(CompanyService);

  selectedCompanyCode: string;
  myControl = new UntypedFormControl();
  filteredCompany: Observable<Company[]>;
  companyList: Company[] = [];
  selectedCompany: number;

  ngOnInit(): void {

    if (this.sharedService.isBranchAccountHandler()) {
      this.selectedCompany = Number(sessionStorage.getItem("companyId"));
    } else {
      this.getAllCompanies();
      //filter company
      this.filteredCompany = this.myControl.valueChanges.pipe(
        startWith(''),
        map(companyCode => this._filterCompanyCodeOptions(companyCode))
      );
    }

  }

  private _filterCompanyCodeOptions(value: string): Company[] {
    const filterValue = value.toLowerCase();
    const filtered = this.companyList.filter(company => { return company.CompanyCode.toLowerCase().includes(filterValue) });

    return filtered;
  }

  async getAllCompanies() {
    //clear company list
    this.companyList.splice(0, this.companyList.length);

    this.companyList = await this.companyService.getAllCompanies();
    if (this.selectedCompany != undefined) this.setSelectedCompanyCode(this.selectedCompany);
  }

  setSelectedCompanyCode(companyId: number) {
    const index = this.companyList.findIndex(company => Number(company.ID) == Number(companyId));
    this.selectedCompany = companyId;
    this.selectedCompanyCode = this.companyList[index].CompanyCode;
  }

  setSelectedCompany(code: string) {
    const index = this.companyList.findIndex(company => company.CompanyCode.toLowerCase() == code.toLowerCase());
    this.selectedCompany = this.companyList[index].ID;

    this.cdr.detectChanges();
  }
}
